import React, { Fragment, useRef } from 'react';
import SVG from 'react-inlinesvg';
import styled from 'styled-components'

const StyledSvg = styled(SVG)`
  [data-turn] {
    cursor: pointer;

    circle[data-active] {
      fill: #01788A !important;
    }

    circle:not([data-active]) {
      fill: #CF0207 !important;
    }

    path {
      fill: white !important;
    }
  }
`;

const setCurrentTurn = (turn, map) => {
  const previousTurn = map.querySelector('circle[data-active]');
  const group = map.querySelector(`g[data-turn="${turn}"]`);
  const circle = group.querySelector('circle');

  previousTurn?.removeAttribute('data-active');
  circle.setAttribute('data-active', true);
};

const onLoad = (map, currentTurn, onTurnChange) => {
  if (currentTurn) setCurrentTurn(currentTurn, map);

  // delegate click events
  map.addEventListener('click', e => {
    const { turn } = e.target.parentNode.dataset;
    if (!turn) return;

    setCurrentTurn(turn, map);
    onTurnChange(turn);
  });
};

const TrackMap = ({ svgUrl, currentTurn, onTurnChange }) => {
  const mapRef = useRef(null);
  const map = mapRef.current

  if (currentTurn && map) setCurrentTurn(currentTurn, map);

  return(
    <StyledSvg src={svgUrl}
         innerRef={mapRef}
         loader="Loading map..."
         onLoad={() => onLoad(mapRef.current, currentTurn, onTurnChange)} />
  );
};

export default TrackMap;
